import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { MenuItem, Select } from "@mui/material";
import DyanmicFromMobile from "../../DyanmicForm/DyanmicFromMobile";
import { useEffect, useState } from "react";
import { fidelioPackages } from "../../../utils/ApiCalls/AddShipMobilePage";
import Swal from "sweetalert2";
import ActionMobileDrop from "../../ActionDropBar/ActionMobileDrop";

const PriceInput = ({ data, setData, sailingId }) => {
  const [packageData, setPackageData] = useState([]);
  const [activeRow, setActiveRow] = useState(
    data?.type === "multiple" ? "display-index" : 0
  );

  const addPriceRow = () => {
    setData({
      ...data,
      data: [...(data.data || []), {}],
    });
  };

  const purchaseDisplayDataTemplate = {
    price: "",
    startText: {
      english: "",
      simplified_chinese: "",
      traditional_chinese: "",
    },
    endText: {
      english: "",
      simplified_chinese: "",
      traditional_chinese: "",
    },
    strikeThrough: "",
  };

  const deleteRow = (index) => {
    if (data.data.length > 1) {
      const updateddata = data.data.filter((_, i) => i !== index);
      setData({ ...data, data: updateddata });
      if (activeRow === index) setActiveRow(null); // 👈 close if deleted
    }
  };

  let remark = [
    {
      title: "Package Name",
      key: "packageName",
      className: "col-lg-2",
      type: "package_name",
    },
    {
      title: "Package ID",
      key: "packageId",
      className: "col-lg-2",
      type: "package_meta",
    },
    {
      title: "Start Text",
      key: "startText",
      className: "col-lg-8",
      type: "multiLang",
    },
    {
      title: "Price",
      key: "price",
      className: "col-lg-2",
      type: "package_meta",
      inputType: "number",
    },
    {
      title: "Strikethrough Price",
      key: "strikeThrough",
      className: "col-lg-2",
      type: "input",
      inputType: "number",
    },
    {
      title: "End Text",
      key: "endText",
      className: "col-lg-8",
      type: "multiLang",
    },
  ];

  const deletePriceRow = (index) => {
    if (index === 0 && data.type === "multiple") {
      setData({
        ...data,
        data: [],
      });
      setActiveRow(1);
    } else if (index === 0) {
      setData({ type: "", data: [] });
      setActiveRow(null);
      return;
    }

    const updateddata = data.data.filter((_, i) => i !== index);

    if (updateddata.length === 0 && data.type === "multiple") {
      setData({
        ...data,
        data: [],
      });

      setActiveRow(1);
    } else if (updateddata.length === 0) {
      setData({ type: "", data: [] });
      setActiveRow(null);
    } else {
      setData({ ...data, data: updateddata });
      if (activeRow === index) setActiveRow(null);
    }
  };

  const handlePriceChange = (index, field, value) => {
    const updateddata = [...data.data];
    updateddata[index] = value;
    setData({ ...data, data: updateddata });
  };

  const handlePurchaseDisplayData = (value) => {
    setData({
      ...data,
      ...(data.type === "multiple" && { purchaseDisplayData: value }),
    });
  };

  useEffect(() => {
    const fetchFidelioPackages = async () => {
      try {
        if (sailingId) {
          const response = await fidelioPackages(sailingId);
          if (response?.error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.error,
            });
            setPackageData([]);
          } else if (!response?.status) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response?.message || "Failed to fetch package data",
            });
            setPackageData([]);
          } else {
            setPackageData(response?.data || []);
          }
        } else {
          setPackageData([]);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Something went wrong while fetching packages",
        });
        setPackageData([]);
      }
    };

    fetchFidelioPackages();
  }, [sailingId]);

  return (
    <div style={{}} className="col-12 row ">
      <div className="col-12 row" style={{ marginBottom: "20px" }}>
        <div className="col-6">
          <label>Price Type</label>
          <Select
            value={data.type || ""}
            style={{ width: "100%", height: "45px" }}
            onChange={(e) => {
              const newType = e.target.value;
              setData({
                type: newType,
                data: newType === "multiple" ? [] : [{}],
                purchaseDisplayData:
                  data?.purchaseDisplayData || purchaseDisplayDataTemplate,
              });

              if (newType === "multiple") {
                setActiveRow("display-index");
              }
            }}
          >
            <MenuItem value="single">Display Price</MenuItem>
            <MenuItem value="multiple">Purchase Price</MenuItem>
          </Select>
        </div>
      </div>

      {data.type && data.type === "multiple" && (
        <div
          className="row col-12 card"
          style={{
            display: "flex",
            padding: "10px",
            alignItems: "center",
            marginBottom: "15px",
            border: "1px solid gray",
          }}
        >
          {activeRow === "display-index" ? (
            <div>
              <div
                className="col-lg-12"
                style={{
                  borderBottom: "1px solid black",
                  paddingBottom: "10px",
                }}
              >
                <ActionMobileDrop
                  title={`Display Purchase Price`}
                  active={activeRow === "display-index"}
                  setActive={() => setActiveRow()}
                  handleDelete={() => deletePriceRow("display-index")}
                />
              </div>
              <DyanmicFromMobile
                display={true}
                error={[]}
                rootData={[
                  data?.purchaseDisplayData || purchaseDisplayDataTemplate,
                ]}
                level={1}
                attributes={remark || []}
                data={data?.purchaseDisplayData || purchaseDisplayDataTemplate}
                setData={(e) => {
                  handlePurchaseDisplayData(e);
                }}
                sailingId={sailingId}
                packageData={packageData}
              />
            </div>
          ) : (
            <div
              onClick={() => setActiveRow("display-index")}
              className="col-12"
              style={{ color: "black", fontWeight: "bold", padding: "5px" }}
            >
              <ActionMobileDrop
                title={`Display Price`}
                active={activeRow === "display-index"}
                setActive={() => setActiveRow()}
                handleDelete={() => deletePriceRow("display-index")}
              />
            </div>
          )}
        </div>
      )}

      {data.type &&
        data?.data?.map((priceRow, index) => (
          <div
            key={index}
            className="row col-12 card"
            style={{
              display: "flex",
              padding: "10px",
              alignItems: "center",
              marginBottom: "15px",
              border: "1px solid gray",
            }}
          >
            {activeRow === index ? (
              <div>
                <div
                  className="col-lg-12"
                  style={{
                    borderBottom: "1px solid black",
                    paddingBottom: "10px",
                  }}
                >
                  <ActionMobileDrop
                    title={`Price ${index + 1}`}
                    active={activeRow === index}
                    setActive={() => setActiveRow()}
                    handleDelete={() => deletePriceRow(index)}
                  />
                </div>
                <DyanmicFromMobile
                  key={`${data.type}-${index}`}
                  error={[]}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={priceRow || {}}
                  setData={(e) => {
                    handlePriceChange(index, "data", e);
                  }}
                  sailingId={sailingId}
                  packageData={packageData}
                />
              </div>
            ) : (
              <div
                onClick={() => setActiveRow(index)}
                className="col-12"
                style={{ color: "black", fontWeight: "bold", padding: "5px" }}
              >
                <ActionMobileDrop
                  title={`Price ${index + 1}`}
                  active={activeRow === index}
                  setActive={() => setActiveRow(index)}
                  handleDelete={() => deletePriceRow(index)}
                />
              </div>
            )}
            {/* <div className="col-12">
              <div className="text-right">
                {index === data.data.length - 1 && (
                  <AddCircleOutlineIcon
                    onClick={addPriceRow}
                    style={{
                      borderRadius: "50%",
                      width: "35px",
                      height: "35px",
                      cursor: "pointer",
                      color: "green",
                    }}
                  />
                )}
                <RemoveCircleOutlineIcon
                  onClick={() => deletePriceRow(index)}
                  style={{
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                    cursor: data.data.length > 1 ? "pointer" : "not-allowed",
                    color: data.data.length > 1 ? "red" : "grey",
                  }}
                />
              </div>
            </div> */}
          </div>
        ))}
      {data?.type && (
        <button
          type="button"
          onClick={addPriceRow}
          style={{ maxWidth: "100px", marginLeft: "10px" }}
          className="btn main_submit"
        >
          Add Item
        </button>
      )}
    </div>
  );
};

export default PriceInput;

//REmove belowcode later

// const PriceInput = ({ data, setData, sailingId }) => {
//   const [packageData, setPackageData] = useState([]);
//   const [activeRow, setActiveRow] = useState(
//     data?.type === "multiple" ? "display-index" : 0
//   );

//   const purchaseDisplayDataTemplate = {
//     price: "",
//     startText: {
//       english: "",
//       simplified_chinese: "",
//       traditional_chinese: "",
//     },
//     endText: {
//       english: "",
//       simplified_chinese: "",
//       traditional_chinese: "",
//     },
//     strikeThrough: "",
//   };

//   const addPriceRow = () => {
//     setData({
//       ...data,
//       data: [...(data.data || []), {}],
//     });
//   };

//   const deletePriceRow = (index) => {
//     if (index === 0 && data.type === "multiple") {
//       setData({
//         ...data,
//         data: [],
//       });
//       setActiveRow(1);
//     } else if (index === 0) {
//       setData({ type: "", data: [] });
//       setActiveRow(null);
//       return;
//     }

//     const updateddata = data.data.filter((_, i) => i !== index);
//     if (updateddata.length === 0 && data.type === "multiple") {
//       setData({
//         ...data,
//         data: [],
//       });
//       setActiveRow(1);
//     } else if (updateddata.length === 0) {
//       setData({ type: "", data: [] });
//       setActiveRow(null);
//     } else {
//       setData({ ...data, data: updateddata });
//       if (activeRow === index) setActiveRow(null);
//     }
//   };

//   const handlePriceChange = (index, field, value) => {
//     const updateddata = [...data.data];
//     updateddata[index] = value;
//     setData({ ...data, data: updateddata });
//   };

//   const handlePurchaseDisplayData = (value) => {
//     setData({
//       ...data,
//       ...(data.type === "multiple" && { purchaseDisplayData: value }),
//     });
//   };

//   useEffect(() => {
//     const fetchFidelioPackages = async () => {
//       try {
//         if (sailingId) {
//           const response = await fidelioPackages(sailingId);
//           if (response?.error) {
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: response.error,
//             });
//             setPackageData([]);
//           } else if (!response?.status) {
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: response?.message || "Failed to fetch package data",
//             });
//             setPackageData([]);
//           } else {
//             setPackageData(response?.data || []);
//           }
//         } else {
//           setPackageData([]);
//         }
//       } catch (error) {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.message || "Something went wrong while fetching packages",
//         });
//         setPackageData([]);
//       }
//     };

//     fetchFidelioPackages();
//   }, [sailingId]);

//   let remark = [];

//   if (data?.type === "multiple") {
//     // only show these when Purchase Price is selected
//     remark = [
//       {
//         title: "Package Name",
//         key: "packageName",
//         className: "col-lg-2",
//         type: "clearable_select",
//         option: packageData.map((pkg) => ({
//           id: pkg.PPN_ID,
//           name: pkg.PPN_NAME,
//           price: pkg.PPN_PRICE,
//         })),
//       },
//       {
//         title: "Package ID",
//         key: "packageId",
//         className: "col-lg-2",
//         type: "input",
//         disabled: true,
//       },
//       {
//         title: "Start Text",
//         key: "startText",
//         className: "col-lg-8",
//         type: "multiLang",
//       },
//       {
//         title: "Price",
//         key: "price",
//         className: "col-lg-2",
//         type: "input",
//         inputType: "number",
//       },
//       {
//         title: "Strikethrough Price",
//         key: "strikeThrough",
//         className: "col-lg-2",
//         type: "input",
//         inputType: "number",
//       },
//       {
//         title: "End Text",
//         key: "endText",
//         className: "col-lg-8",
//         type: "multiLang",
//       },
//     ];
//   } else {
//     // when not multiple → skip package fields
//     remark = [
//       {
//         title: "Start Text",
//         key: "startText",
//         className: "col-lg-8",
//         type: "multiLang",
//       },
//       {
//         title: "Price",
//         key: "price",
//         className: "col-lg-2",
//         type: "input",
//         inputType: "number",
//       },
//       {
//         title: "Strikethrough Price",
//         key: "strikeThrough",
//         className: "col-lg-2",
//         type: "input",
//         inputType: "number",
//       },
//       {
//         title: "End Text",
//         key: "endText",
//         className: "col-lg-8",
//         type: "multiLang",
//       },
//     ];
//   }

//   return (
//     <div className="col-12 row">
//       <div className="col-12 row" style={{ marginBottom: "20px" }}>
//         <div className="col-6">
//           <label>Price Type</label>
//           <Select
//             value={data.type || ""}
//             style={{ width: "100%", height: "45px" }}
//             onChange={(e) => {
//               const newType = e.target.value;
//               setData({
//                 type: newType,
//                 data: newType === "multiple" ? [] : [{}],
//                 purchaseDisplayData:
//                   data?.purchaseDisplayData || purchaseDisplayDataTemplate,
//               });

//               if (newType === "multiple") {
//                 setActiveRow("display-index");
//               }
//             }}
//           >
//             <MenuItem value="single">Display Price</MenuItem>
//             <MenuItem value="multiple">Purchase Price</MenuItem>
//           </Select>
//         </div>
//       </div>

//       {data.type === "multiple" && (
//         <div
//           className="row col-12 card"
//           style={{
//             display: "flex",
//             padding: "10px",
//             alignItems: "center",
//             marginBottom: "15px",
//             border: "1px solid gray",
//           }}
//         >
//           {activeRow === "display-index" ? (
//             <div>
//               <div
//                 className="col-lg-12"
//                 style={{
//                   borderBottom: "1px solid black",
//                   paddingBottom: "10px",
//                 }}
//               >
//                 <ActionMobileDrop
//                   title={`Display Purchase Price`}
//                   active={activeRow === "display-index"}
//                   setActive={() => setActiveRow()}
//                   handleDelete={() => deletePriceRow("display-index")}
//                 />
//               </div>
//               <DyanmicFromMobile
//                 display={true}
//                 error={[]}
//                 rootData={[
//                   data?.purchaseDisplayData || purchaseDisplayDataTemplate,
//                 ]}
//                 level={1}
//                 attributes={remark.filter(
//                   (r) => r.key !== "packageName" && r.key !== "packageId"
//                 )}
//                 data={data?.purchaseDisplayData || purchaseDisplayDataTemplate}
//                 setData={(e) => {
//                   handlePurchaseDisplayData(e);
//                 }}
//                 sailingId={sailingId}
//                 packageData={packageData}
//               />
//             </div>
//           ) : (
//             <div
//               onClick={() => setActiveRow("display-index")}
//               className="col-12"
//               style={{ color: "black", fontWeight: "bold", padding: "5px" }}
//             >
//               <ActionMobileDrop
//                 title={`Display Price`}
//                 active={activeRow === "display-index"}
//                 setActive={() => setActiveRow()}
//                 handleDelete={() => deletePriceRow("display-index")}
//               />
//             </div>
//           )}
//         </div>
//       )}

//       {data.type &&
//         data?.data?.map((priceRow, index) => (
//           <div
//             key={index}
//             className="row col-12 card"
//             style={{
//               display: "flex",
//               padding: "10px",
//               alignItems: "center",
//               marginBottom: "15px",
//               border: "1px solid gray",
//             }}
//           >
//             {activeRow === index ? (
//               <div>
//                 <div
//                   className="col-lg-12"
//                   style={{
//                     borderBottom: "1px solid black",
//                     paddingBottom: "10px",
//                   }}
//                 >
//                   <ActionMobileDrop
//                     title={`Price ${index + 1}`}
//                     active={activeRow === index}
//                     setActive={() => setActiveRow()}
//                     handleDelete={() => deletePriceRow(index)}
//                   />
//                 </div>

//                 <DyanmicFromMobile
//                   key={`${data.type}-${index}`}
//                   error={[]}
//                   rootData={data}
//                   level={1}
//                   attributes={remark}
//                   data={priceRow || {}}
//                   setData={(e) => {
//                     const selected = packageData.find(
//                       (p) =>
//                         p.PPN_ID === e.packageName ||
//                         p.PPN_NAME === e.packageName
//                     );

//                     const updated = {
//                       ...e,
//                       packageId: selected?.PPN_ID || e.packageId || "",
//                     };

//                     handlePriceChange(index, "data", updated);
//                   }}
//                   sailingId={sailingId}
//                   packageData={packageData}
//                 />
//               </div>
//             ) : (
//               <div
//                 onClick={() => setActiveRow(index)}
//                 className="col-12"
//                 style={{ color: "black", fontWeight: "bold", padding: "5px" }}
//               >
//                 <ActionMobileDrop
//                   title={`Price ${index + 1}`}
//                   active={activeRow === index}
//                   setActive={() => setActiveRow(index)}
//                   handleDelete={() => deletePriceRow(index)}
//                 />
//               </div>
//             )}
//           </div>
//         ))}
//       {data?.type && (
//         <button
//           type="button"
//           onClick={addPriceRow}
//           style={{ maxWidth: "100px", marginLeft: "10px" }}
//           className="btn main_submit"
//         >
//           Add Item
//         </button>
//       )}
//     </div>
//   );
// };

// export default PriceInput;
